import { Modal, ModalProps } from "react-bootstrap";

interface HobbyResultConfirmModalProps extends ModalProps {
  onHide: () => void;
  selectionName: string;
  imageUrl: string;
  fallbackImage?: string;
  onConfirm: () => void;
}

const HobbyResultConfirmModal = (props: HobbyResultConfirmModalProps) => {
  const { selectionName, imageUrl, fallbackImage, onConfirm, onHide, ...modalProps } = props;
  const resolvedFallback = fallbackImage || imageUrl;

  return (
    <Modal
      {...modalProps}
      className="selectHobbyConfirmModal"
      keyboard={false}
      centered
      scrollable={false}
      onHide={onHide}
    >
      <Modal.Body className="px-0">
        <div className="otpModalBody py-2">
          <div className="header mb-3">You selected</div>
          {/* <div className="selectHobbyConfirmName">{selectionName}</div> */}
          <div className="selectHobbyConfirmImageWrap">
            <img
              src={imageUrl || resolvedFallback}
              alt={selectionName}
              onError={(e) => {
                const el = e.currentTarget;
                if (!el.dataset.fallbackApplied) {
                  el.dataset.fallbackApplied = "1";
                  el.src = resolvedFallback;
                }
              }}
            />
          </div>
          <div className="selectHobbyConfirmActions">
            <button type="button" className="btnYesMenu" onClick={onConfirm}>
              Yes
            </button>
            <button type="button" className="btnCancelMenu" onClick={onHide}>
              No
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default HobbyResultConfirmModal;
